/* eslint-disable quote-props */
/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

const licFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "What kind of support do I get from Wealthy?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Once you finish your KYC verification, you will be assigned a dedicated relationship manager. They will help you with sales closures, product research & selection, portfolio reviews and business growth ideas. Regular training and marketing support is provided for your business growth."
    }
  }, {
    "@type": "Question",
    "name": "How do I receive a payout?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "We offer payouts on a monthly basis for all products except insurance. For insurance products, the payout is done on issuance after the free look-in period. We also offer two payout cycles to ensure faster settlement. We make it simple for you to track and calculate your earnings from the dashboard."
    }
  }, {
    "@type": "Question",
    "name": "Is my ARN mapped under Wealthy?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The master ARN will be Wealthy, and your ARN will be used as a sub-broker for all the transactions."
    }
  }, {
    "@type": "Question",
    "name": "On which platform are you executing the transactions?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "All your transactions will be executed on the wealthy platform. Not just transactions, it will also help you monitor and track your clients' portfolios. You shall also get an app to monitor your business as well as the clients."
    }
  }, {
    "@type": "Question",
    "name": "Can I carry out offline transactions on Wealthy?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, offline transactions can be done. You need to submit the application form, scheme copy and KYC details of the clients to the relationship managers (RMs) or to the nearest POS. The request will be processed once we receive it."
    }
  }, {
    "@type": "Question",
    "name": "Can I offer other products to the clients apart from mutual funds?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, we are a multi-product platform. You can offer equity, insurance, NCDs, Bonds & Debentures, Credit Cards and FDs. We will update you about every new product."
    }
  }, {
    "@type": "Question",
    "name": "What is the process to join Wealthy as an MFD?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You must complete the KYC by submitting your PAN, Aadhaar, and bank details on the app. Once you add your clients, you can start transacting immediately."
    }
  }, {
    "@type": "Question",
    "name": "Will I get commission if my client does transactions on the app?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, Once the client is mapped to you, any transaction that the client does will be treated as your business. You will be eligible to earn a commission on the same."
    }
  }, {
    "@type": "Question",
    "name": "Will Wealthy help me get an ARN?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, we will help you train for the NISM exam and assist you throughout the process."
    }
  }]
}
;

export default licFaqSchema;
